import { useEffect, useState } from 'react';
import { getGmSecret, isGm } from '../lib/gm.js';

/**
 * Хук, що реактивно відображає GM-стан. Слухає custom-подію 'sd:gm-changed',
 * яку емітить setGmSecret, і storage-event від інших табів.
 */
export function useGm(): { isGm: boolean; secret: string | null } {
  const [state, setState] = useState({ isGm: isGm(), secret: getGmSecret() });

  useEffect(() => {
    function sync(): void {
      setState({ isGm: isGm(), secret: getGmSecret() });
    }
    window.addEventListener('sd:gm-changed', sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener('sd:gm-changed', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return state;
}
